
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/integrations/[integrationsPages]",
      function () {
        return require("private-next-pages/integrations/[integrationsPages].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/integrations/[integrationsPages]"])
      });
    }
  